const AnimateDirective = {
  /**
   * 元素插入DOM时触发动画
   * @param {HTMLElement} el - 指令绑定的元素
   */
  inserted(el, binding) {
    let threshold = null;
    const computedTransform = window.getComputedStyle(el).transform;
    let oTranslateX,oTranslateY,oScaleX,oScaleY
    if (computedTransform !== "none") {
      // 将矩阵字符串转换为DOMMatrix对象
      const matrix = new DOMMatrix(computedTransform);
      // 提取参数（以2D变换为例）
      oTranslateX = matrix.e; // X轴位移（px）
      oTranslateY = matrix.f; // Y轴位移（px）
      oScaleX = matrix.a; // X轴缩放比例
      oScaleY = matrix.d; // Y轴缩放比例
    }
    if (binding.arg === "threshold") {
      threshold = binding.value;
    }

    // 设置初始状态
    el.style.opacity = "0";
    el.style.transform = `${oTranslateX ? 'translateX(oTranslateX)':''} translateY(40px)`;
    el.style.willChange = "opacity, transform"; // 优化性能

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 添加过渡效果
            el.style.transition =
              "opacity 600ms ease-out, transform 600ms ease-out";

            // 强制重绘确保动画生效
            void el.offsetHeight;

            // 应用结束状态
            el.style.opacity = "1";
            el.style.transform = `${oTranslateX ? 'translateX(oTranslateX)':''} ${oTranslateY ? 'translateY(oTranslateY)' : 'translateY(0)'}`;

            // 动画完成后清理
            const cleanUp = () => {
              el.style.willChange = "auto";
              el.removeEventListener("transitionend", cleanUp);
              observer.unobserve(el);
            };
            el.addEventListener("transitionend", cleanUp);
          }
        });
      },
      { threshold: threshold || 0.15 } // 当元素75%进入视口时触发
    );

    observer.observe(el);
  },
};

export default AnimateDirective;
